// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrUrl, .totpCode {
  width: 100%;
  padding: 20px;
  text-align: center;
  margin-bottom: 10px; /* Optional spacing between divs */
  word-break: break-all;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
